import { remove } from "@src/appV2/api";
import { environmentConfig } from "@src/appV2/environment";
import { APP_V2_APP_EVENTS } from "@src/appV2/lib/analytics";
import { useMutation, type UseMutationOptions } from "@tanstack/react-query";
import { z } from "zod";
import { useTu } from "@src/appV2/i18n/useTu";

interface CancelPlacementAutoInviteParams {
  placementApplicationId: string;
  workplaceId: string;
}

export function useCancelPlacementAutoInvite(
  options: UseMutationOptions<void, Error, CancelPlacementAutoInviteParams> = {}
) {
  const { tu } = useTu("chat");
  return useMutation({
    mutationFn: async (params: CancelPlacementAutoInviteParams) => {
      const { placementApplicationId, workplaceId } = params;

      await remove({
        url: `${environmentConfig.REACT_APP_API_MAIN_URL}/api/workplaces/${workplaceId}/placement-applications/${placementApplicationId}/interviews/auto-invites`,
        responseSchema: z.unknown(),
      });
    },
    meta: {
      logErrorMessage: APP_V2_APP_EVENTS.PLACEMENT_APPLICATION_AUTO_INVITE_CANCEL_FAILURE,
      userSuccessMessage: tu("Your message was canceled successfully."),
      userErrorMessage: tu("Failed to cancel message"),
    },
    ...options,
  });
}
